export const closeForm = () => window.formHandler.appCloseWebView(null);
export const addZeros = number => {
  switch (String(number).length) {
    case 1:
      return '000' + number;
    case 2:
      return '00' + number;
    case 3:
      return '0' + number;
    default:
      return number;
  }
};
